import React from "react";
import {
  Datagrid,
  Filter,
  List,
  TextField,
  SearchInput,
  ListProps,
  SelectInput,
} from "react-admin";
import { Helmet } from "react-helmet";
import TypeField from "../../components/TypeField";
import StatusField from "../../components/StatusField";
import CustomDateField from "../../components/CustomDateField";
import { statusList } from "./const";
import CustomPagination from "../../components/CustomPagination";

const EmailLogFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput label="Status" source="Status" choices={statusList} alwaysOn />
  </Filter>
);

const EmailLogList = (props: ListProps) => (
  <>
    <Helmet>
      <title>Email Sending Logs</title>
    </Helmet>
    <List
      exporter={false}
      filters={<EmailLogFilter />}
      sort={{ field: "CreatedAt", order: "DESC" }}
      bulkActionButtons={false}
      perPage={50}
      {...props}
      pagination={<CustomPagination />}
    >
      <Datagrid rowClick={null}>
        <TextField source="id" />
        <TextField source="email" label="Email" />
        <TypeField
          source="emailType"
          type="emailSendingLog_Type"
          label="Email Type"
        />
        <TextField source="log" emptyText="-" />
        <StatusField source="status" />
        <CustomDateField source="createdAt" isDateTime />
      </Datagrid>
    </List>
  </>
);

export default EmailLogList;
